import _default from './Item';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/views/Item/index.js
// module id = 2884
// module chunks = 0